/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Routes } from 'react-router';

import { SkipNavContent, ErrorBoundary } from 'sarsaparilla';

import { Footer } from 'site-kit';
import { ExternalPageFrame } from 'shared-ui/external-app-base';
import ErrorPage from 'shared-ui/components/ErrorPage/ErrorPage';
import { TopNavigationExternal } from 'shared-ui/TopNavigationExternal';

import { useAccountType } from '../src/shared/hooks';

import makeSwitchRoutes from './makeSwitchRoutes';

const routes = makeSwitchRoutes();

export default function App() {
    useAccountType();

    return (
        <ExternalPageFrame>
            <TopNavigationExternal isGuestAllowed />

            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent className="rec-page">
                    <Routes>{routes}</Routes>
                </SkipNavContent>
            </ErrorBoundary>

            <Footer />
        </ExternalPageFrame>
    );
}

if (process.env.REACT_AXE_ENV === 'local') {
    // eslint-disable-next-line
    const { default: axe } = await import('@axe-core/react');
    axe(React, ReactDOM, 5000);
}
